// extracted by mini-css-extract-plugin
module.exports = {"doctor-services-container":"DoctorServices_doctor-services-container__1hMs6","list-of-services":"DoctorServices_list-of-services__36qH2"};